// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

// Additional Libraries
import { js_mouse, device_sniffer } from './modules/page';

// Swup setup
import Swup from 'swup';

import ScrollPlugin from '@swup/scroll-plugin';
import BodyClassPlugin from '@swup/body-class-plugin';

const scroll_options = {
	doScrollingRightAway: false,
	animateScroll: true,
	scrollFriction: 0.3,
	scrollAcceleration: 0.04,
}

const options = {
	plugins: [
		new BodyClassPlugin(),
		new ScrollPlugin(scroll_options),
	],
	containers: [
		'#body-wrapper',
	],
};

const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	js_mouse();
	device_sniffer();
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => routes.loadEvents());

swup.on('animationOutEnd', function(){
	$('.cursor').text('');
	$('.cursor').removeClass('link-hovered reverse-hovered');
	$('.cursor').attr('data-dir', '');
});



// WEBPACK FOOTER //
// ./scripts/main.js